// copied from https://github.com/bangthetable/blue-haven/blob/develop/src/lib/PrepareQuery.js

import { isPresent } from 'lib/Helper'

// This function builds the API body params
// It's necessary to add when we use the api's with pagination and filters
class Query {
  constructor(query = {}, filters = {}) {
    for (const key in query) {
      let value = query[key]
      if (value && isPresent(value)) {
        this[key] = query[key]
      }
    }

    for (const key in filters) {
      let value = filters[key]
      if (isPresent(value)) {
        if (!this.filters) {
          this.filters = {}
        }
        this.filters[key] = value
      }
    }
  }
}

export default Query
